const clientId =
  (window.APP_CONFIG && window.APP_CONFIG.CLIENT_ID) ||
  process.env.REACT_APP_CLIENT_ID ||
  "";

const tenantId =
  (window.APP_CONFIG && window.APP_CONFIG.TENANT_ID) ||
  process.env.REACT_APP_TENANT_ID ||
  "common";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const redirectUri = isLocalhost
  ? window.location.origin + "/auth-redirect.html"
  : window.location.origin;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// loginRequest — used for the initial sign-in popup/redirect.
// Includes the app's own API scope so the access token audience
// matches AZURE_CLIENT_ID on the backend (not Microsoft Graph).
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    `api://${clientId}/access_as_user`,  // ← this makes the token audience = clientId
  ],
};